export default __webpack_public_path__ + "static/media/header_logo_ikara.10fb9c30.svg";